function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg02N(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.995,
    height: 25.071,
    viewBox: "0 0 37.995 25.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "02n"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184450"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14410",
    d: "M250.751 64.731a4.878 4.878 0 0 0-4.817-3.773 5.013 5.013 0 0 0-3.068 1.037 8.73 8.73 0 0 0-7.8-4.671 8.587 8.587 0 0 0-8.621 7.3 5.8 5.8 0 0 0-4.649 5.582 5.856 5.856 0 0 0 5.947 5.725h21.279a5.856 5.856 0 0 0 5.947-5.725 5.778 5.778 0 0 0-4.218-5.475z",
    transform: "translate(-221.797 -50.862)",
    style: {
      fill: "#d32f2f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184448"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14411",
    d: "M246.054 64.494a6.9 6.9 0 0 1 5.586-2.981.413.413 0 0 0 0-.826 7.768 7.768 0 0 0-6.3 3.39c-.306.436.41.85.713.417z",
    transform: "translate(-238.394 -53.239)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184449"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14412",
    d: "M226.392 91.457a4.487 4.487 0 0 1 2.1-3.739c.446-.286.033-1-.417-.713a5.342 5.342 0 0 0-2.513 4.452.413.413 0 0 0 .826 0z",
    transform: "translate(-224.462 -71.804)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184621"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14526",
    d: "M3.809 11.13A5.673 5.673 0 0 1 0 9.656h.367A6.057 6.057 0 0 0 5.233 0a5.656 5.656 0 0 1-1.424 11.128z",
    transform: "rotate(105.01 17.803 16.128)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14527",
    d: "M3.654.762A.161.161 0 0 0 3.766.68L4.141 0l.373.68a.161.161 0 0 0 .112.082l.762.146-.53.566a.154.154 0 0 0-.043.131l.1.768-.7-.328a.154.154 0 0 0-.137 0l-.7.328.1-.768a.159.159 0 0 0-.041-.131L2.892.908zM.322 3.922l.062-.5a.159.159 0 0 0-.043-.131L0 2.929l.491-.09A.167.167 0 0 0 .6 2.757l.24-.429.242.429a.159.159 0 0 0 .109.082l.491.092-.348.363a.165.165 0 0 0-.043.131l.062.5-.448-.217a.165.165 0 0 0-.137 0zm4.171 1.333a.161.161 0 0 0-.041.131l.062.5-.453-.215a.159.159 0 0 0-.069-.015.152.152 0 0 0-.069.015l-.453.215.062-.5a.163.163 0 0 0-.043-.131l-.341-.365.491-.09a.163.163 0 0 0 .112-.079l.242-.44.24.44a.163.163 0 0 0 .112.079l.491.094z",
    transform: "rotate(105.01 18.1 15.098)",
    style: {
      fill: "#283593"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02N);
export default __webpack_public_path__ + "static/media/02N.0f8f568ecbbc2075fd1b2fe254bf3812.svg";
export { ForwardRef as ReactComponent };